import LayoutHandler from '../classic/navigation'
/**
 * JavaScript fuer das Hauptmenue
 */

const modern = function () {
    // Offcanvas Sidebar in mobiler Ansicht

    function collapse() {
        var toggleElement = $('#wrapper');
        var storageName = "Esearcher.navigation.collapsed";

        // check state
        toggleElement.toggleClass('extend');
        var isExtended = toggleElement.hasClass('extend');

        // save extended status
        localStorage[storageName] = isExtended;
        Cookies.set(storageName, isExtended);

        // switch classes
        $('ul.nav.collapse').removeClass('in');
        $('a.menu-group-head').removeClass('collapsed');
        $('a.menu-group-head').addClass('collapsed');
        if ($('#wrapper').hasClass('extend')) {
            $('#top-navbar-toggle').removeClass('hide-quick-menu');
        } else {
            $('#top-navbar-toggle').addClass('hide-quick-menu');
        }
    }

    function collapseSidebarMenu() {
        if ($('#wrapper').hasClass('extend')) {
            $('ul.nav.collapse').removeClass('in');
            $('#wrapper').removeClass('extend');
        }

        // store last clicked navigation item or reset storage key
        if ($(this).hasClass("collapsed")) {
            localStorage["Esearcher.navigation.last_open_parent"] = $(this).prop("id");
            localStorage["Esearcher.navigation.last_open_target"] = $(this).data("target");
        } else {
            localStorage["Esearcher.navigation.last_open_parent"] = null;
            localStorage["Esearcher.navigation.last_open_target"] = null;
        }

    }

    $('a.menu-group-head').addClass('collapsed');
    $('[data-toggle=offcanvasExtended]').click(collapse);
    $('.menu-group-head').click(collapseSidebarMenu);
    var menuToggledByDefault = $('ul.sidebar-menu').data('menutoggeldbydefault');

    if (typeof localStorage['Esearcher.navigation.collapsed'] != 'undefined' && !menuToggledByDefault) {
        if ($('#wrapper').hasClass('extend') != JSON.parse(localStorage['Esearcher.navigation.collapsed'])) {
            collapse();
        }
    }

    // open last clicked navigation block
    if (typeof localStorage["Esearcher.navigation.last_open_target"] !== "undefined"
        && typeof localStorage["Esearcher.navigation.last_open_parent"] !== "undefined") {
        $(localStorage["Esearcher.navigation.last_open_target"]).addClass("in");
        $("#" + localStorage["Esearcher.navigation.last_open_parent"]).removeClass("collapsed");
    }

};

export default modern;

function resizeIframe(obj) {
    obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
}


